import { Typography } from '@mui/material';
import { NavBarAnalytics } from '@ankr.com/ui';

import { ChainSelectors } from 'modules/chains/components/ChainSelectors';
import { NavLink } from 'uiKit/NavLink';
import { Timeframes } from 'modules/chains/components/Timeframes';
import { statisticsRoutesConfig } from 'domains/statistics/routes';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { headerTranslation } from './translation';
import { useHeaderStyles } from './useHeaderStyles';

export const Header = () => {
  const { classes } = useHeaderStyles();

  const { keys, t } = useTranslation(headerTranslation);

  return (
    <div className={classes.root}>
      <div className={classes.topRow}>
        <Typography color="textPrimary" variant="subtitle1">
          {t(keys.statistics)}
        </Typography>
        <div className={classes.left}>
          <Timeframes className={classes.timeframes} />
          <NavLink
            className={classes.statisticsButton}
            href={statisticsRoutesConfig.statistics.generatePath()}
            size="small"
            startIcon={<NavBarAnalytics className={classes.icon} />}
            variant="outlined"
          >
            {t(keys.statistics)}
          </NavLink>
        </div>
      </div>
      <ChainSelectors className={classes.selectors} />
    </div>
  );
};
